<template>
  <div class="picture-content">
    <base-img-viewer class="d-flex flex-column" style="height: 100%">
      <div class="content-row">
        <base-img-base
          class="picture-item"
          :height="'60px'"
          style="margin-right:10px; min-width: 150px;"
          ref="headImg" :src="plate"
          :alt="'车牌图'"></base-img-base>
        <div
          class="plate-text plate"
          :style="{backgroundColor:_plateColor,color:plateNumberColor,fontSize:fontSize,height:'60px'}">
          {{ plateNumberText }}
        </div>
      </div>
      <div class="content-row">
        <base-img-base
          class="picture-item"
          style="margin-right: 10px;height: 150px"
          ref="headImg" :src="head"
          :alt="'车头图'"></base-img-base>
        <base-img-base
          class="picture-item"
          style="margin-right: 10px;height: 150px"
          ref="headImg" :src="tail"
          :alt="'车尾图'"></base-img-base>
        <!--        这里显示一些车辆的字段-->
        <!--        <div class="carDetailContent" style="min-width: 200px;height: 150px">-->
        <!--          <div-->
        <!--            class="d-flex align-center"-->
        <!--            v-for="item of [-->
        <!--           {label:'变道：',value:carDetail.changeLane},-->
        <!--           {label:'遮挡：',value:carDetail.cover},-->
        <!--           {label:'设备编号：',value:carDetail.deviceCode},-->
        <!--           {label:'车头抓拍时间：',value:carDetail.captureTime},-->
        <!--           {label:'车身抓拍时间：',value:carDetail.sideCaptureTime},-->
        <!--         ]">-->
        <!--            <div class="label">{{ item.label }}</div>-->
        <!--            <div class="value">{{ item.value }}</div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="content-row">
        <base-img-base
          class="picture-item"
          style="height: 200px"
          ref="sideImg" :src="side"
          :alt="'车身图'"></base-img-base>
      </div>
      <div class="content-row" style="flex: 1">
        <div class="carDetailContent-bottom">
          <div
            class="d-flex align-center field"
            v-for="item of [
           {label:'变道：',value:carDetail.changeLane,minWidth:50},
           {label:'遮挡：',value:carDetail.cover,minWidth:50},
           {label:'设备编号：',value:carDetail.deviceCode,minWidth:80},
           {label:'车头抓拍时间：',value:carDetail.headCaptureTime,minWidth:100},
           {label:'车身抓拍时间：',value:carDetail.sideCaptureTime,minWidth:100},
         ]">
            <div class="label" :style="{minWidth:item.minWidth+'px'}">{{ item.label }}</div>
            <div class="value">{{ item.value || '--' }}</div>
          </div>
        </div>
      </div>
    </base-img-viewer>
  </div>
</template>
<style scoped lang="scss">
.carDetailContent-bottom {
  display: flex;
  flex-wrap: wrap;
  .field {
    padding: 0 10px;
    .label {
      color:#63dcd8;
      font-weight: bold;
    }
    .value {
    }
  }
}
// 图片容器
.picture-content {
  height: 100%;
  .content-row {
    display: flex;
    margin-bottom: 10px;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-between;
    padding-top: 10px;
    align-items: center;
    .picture-item {
      flex: 1;
      height: 100%;
      background: #061e2e;
      margin-bottom: 10px
    }
    // 车辆的一些字段
    .carDetailContent {
      box-sizing: border-box;
      flex: 1;
      background: #061e2e;
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 20px;
      font-size: 12px;
      .label {
        min-width: 80px;
        font-weight: bold;
      }
      .value {
      }
    }
    .plate-text {
      flex: 1;
      min-width: 150px;
      background: #061e2e;
      color: #999;
      margin-bottom: 10px
    }
  }
}
// 车牌显示
.plate {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  min-height: 45px;
}

</style>

<!--☯js-->
<script>
  let life = {}; let event = {}; let watch = {}
  import * as modelJS from '../../../../../../src/business-components/page-picture-contentV2/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  const methodsSource = {}
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-business-page-picture-contentV2')
  export default {
    name: 'business-page-picture-contentV2', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'business-page-picture-contentV2': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../../base-components/account-info/index.vue').default,
       'base-back': require('./../../base-components/back/index.vue').default,
       'base-blackHandle': require('./../../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../../base-components/check-all/index.vue').default,
       'base-cropper': require('./../../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../../base-components/dialog/index.vue').default,
       'base-empty': require('./../../base-components/empty/index.vue').default,
       'base-export': require('./../../base-components/export/index.vue').default,
       'base-filter': require('./../../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../../base-components/key-value/index.vue').default,
       'base-my-column': require('./../../base-components/my-column/index.vue').default,
       'base-number-input': require('./../../base-components/number-input/index.vue').default,
       'base-plate': require('./../../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../../base-components/yearrange/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>